// components/FormStepper.jsx

const FormStepper = ({ currentPage, visitedPages, goToPage, steps }) => {
  return (
    <div className="stepper-container mb-4">
      <div className="stepper">
        {steps.map((step, index) => (
          <div key={index} className="stepper-item">
            <button
              type="button"
              className={`stepper-button ${currentPage === index ? 'active' : ''} ${
                visitedPages.has(index) ? 'visited' : ''
              }`}
              onClick={() => goToPage(index)}
              disabled={!visitedPages.has(index)}
            >
              <div className="stepper-icon">
                {visitedPages.has(index) ? (
                  <i className="bi bi-check"></i>
                ) : (
                  <span>{index + 1}</span>
                )}
              </div>
              <span className="stepper-label">{step.label}</span>
            </button>
            {index < steps.length - 1 && <div className="stepper-line"></div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormStepper;